<template>
  <section class="f-34">
    <div
      class="alive_content f-select-center"
      v-ia
      v-bg
      bg-url="@/v2/auto/assets/image/34/0.jpg"
    >
      <div class="title f-center-title">
        <div>海量 AI 壁纸</div>
        <div>应有尽有</div>
      </div>
      <div class="des f-center-sub-title">
        <div>一句话即可生成 AI 壁纸</div>
        <div>也可前往图库将储存的照片 AI 风格化</div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      preload_: true,
    }
  },
  mounted() {},
  methods: {},
}
</script>
<style lang="less" scoped>
.f-34 {
  height: 1100px;
  width: 100%;
  position: sticky;
  z-index: 79;
  display: flex;
  justify-content: center;
  align-items: center;
  .alive_content {
    border-radius: 20px;
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    .title {
      margin: 10% 0 0 10%;
      display: flex;
      flex-direction: column;
      line-height: 1.2;
      width: max-content;
      // 设置背景
      background: radial-gradient(
        120.01% 677.74% at 1.57% 10.13%,
        #2e63ca 0%,
        #91a8e4 100%
      );
      // 背景作用于字体上
      background-clip: text;
      // 字体透明
      color: transparent;
      font-weight: 700;
    }
    .des {
      margin: 10px 0 0 10%;
      line-height: 1.5;
      color: #00000080;
      width: 100%;
    }
  }
}
</style>
